<template></template>

<script setup lang="ts">
import { watch } from "vue";

import { useAuditStore } from "../../features/audit/store.js";
import { useCompetitorsStore } from "../../features/competitors/store.js";
import { useMappingsStore } from "../../features/mappings/store.js";
import { useMonitoringStore } from "../../features/monitoring/store.js";
import { useNotificationsStore } from "../../features/notifications/store.js";
import { usePoliciesStore } from "../../features/policies/store.js";
import { useProductsStore } from "../../features/products/store.js";
import { useRequestsStore } from "../../features/requests/store.js";
import { useMerchantToastStore } from "../../features/shared-ui/toast-store.js";
import { useStoreSettingsStore } from "../../features/store-settings/store.js";
import { useTeamAccessStore } from "../../features/team-access/store.js";
import { useWidgetSettingsStore } from "../../features/widget-settings/store.js";

const toasts = useMerchantToastStore();

installMutationToast("competitors", () => useCompetitorsStore().mutationMessage);
installMutationToast("mappings", () => useMappingsStore().mutationMessage);
installMutationToast("monitoring", () => useMonitoringStore().mutationMessage);
installMutationToast("notifications", () => useNotificationsStore().mutationMessage);
installMutationToast("policies", () => usePoliciesStore().mutationMessage);
installMutationToast("products", () => useProductsStore().mutationMessage);
installMutationToast("requests", () => useRequestsStore().mutationMessage);
installMutationToast("store-settings", () => useStoreSettingsStore().mutationMessage);
installMutationToast("team-access", () => useTeamAccessStore().mutationMessage);
installMutationToast("widget-settings", () => useWidgetSettingsStore().mutationMessage);

function installMutationToast(_source: string, message: () => string | undefined): void {
  watch(message, (next, previous) => {
    if (next === undefined || next === previous) return;
    toasts.success(next);
  });
}
</script>
